<template>

    <Toast/>

    <MenuFinancialCompact v-if="userStore.user?.roles?.includes('ROLE_ISORISE')"/>
    <MenuHealthCompact v-else/>

    <div class="px-6 surface-overlay relative">

        <div v-show="activeTab === 1" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <ul class="list-none py-2 px-0 m-0 flex align-items-center font-medium overflow-x-auto w-full">
                        <li class="pr-3"><a class="cursor-pointer">Help</a></li>
                        <li class="px-2"><i class="pi pi-angle-right text-900"></i></li>
                        <li class="px-2"><a class="cursor-pointer text-900 white-space-nowrap">Welcome</a></li>
                    </ul>

                    <h3>Quick Introduction to IsoEvolve</h3>

<!--                    <div class="grid">-->
<!--                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">-->
<!--                            <li>-->
<!--                                <a @click="callUserManual" v-ripple-->
<!--                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">-->
<!--                                    <i class="pi pi-plus-circle mr-2"></i>-->
<!--                                    <span>User Manual</span>-->
<!--                                </a>-->
<!--                            </li>-->
<!--                        </ul>-->
<!--                    </div>-->

                    <div class="col-12 md:col-12">
                        <div class="card p-fluid">
                            <h2>Welcome!</h2>

                            <h3>
                                You now have the Business Clarity Software to connect your time, money, and operations
                                in
                                one calm, powerful system – so you can grow without chaos.
                            </h3>

                            <h3>Let us help you navigate the IsoEvolve software so that you can get the best experience
                                possible and optimise your learning and upskilling time. Everything going well, you
                                should be
                                setup
                                within 5-10 minutes, and worst case 1.5 hours if you watch our full training video.
                            </h3>

                            <div class="flex flex-column gap-2">
                                <div class="field flex align-items-center gap-2 mb-4">
                                    <InputSwitch v-model="skipWelcome" @change="onShowWelcomeChange"/>

                                    <span class="text-900 font-medium line-height-1 m-0">
                                    Skip this page next time
                                </span>
                                </div>

                                <div class="field">
                                <span>
                                    <strong>Step 1:</strong>
                                    To understand the IsoEvolve software in a nutshell, and how you can benefit from
                                    using it to help in your business, watch the Quick Start Guide training video below.
                                    Note that the video is around 10 minutes and should help you get your configuration,
                                    your first client, appointment, invoice and payment completed.
                                    You can also speed up the video if that makes sense for you.
                                </span>
                                </div>

                                <div class="field">
                                <span>
                                    <strong>Step 2:</strong>
                                    To understand the IsoEvolve software fully, watch the Overview and Setup training
                                    video below. Note that the video is around 82 minutes and you can watch it in stages
                                    if you can't dedicate the time immediately. You can also speed up the video if that
                                    makes sense for you.
                                </span>
                                </div>

                                <div class="field">
                                <span>
                                    <strong>Step 3:</strong>
                                    Configure your account here (estimated time : 5 minutes) -
                                    <a href="#" @click.prevent="processConfiguration">Start Configuring My Account</a>
                                </span>
                                </div>

                                <div class="field">
                                <span>
                                    <strong>Step 4:</strong>
                                    Create your first client (estimated time : 1 minute) -
                                    <a href="#" @click.prevent="processClient">Create First Client</a>
                                </span>
                                </div>

                                <div class="field">
                                <span>
                                    <strong>Step 5:</strong>
                                    Create your first appointment using the Calendar (estimated time : 30 seconds) -
                                    <a href="#" @click.prevent="processAppointment">Create First Appointment</a>
                                </span>
                                </div>

                                <div class="field">
                                <span>
                                    <strong>Step 6:</strong>
                                    Create your first invoice using the appointment on the Calendar and submit it to the client
                                    (estimated time : 30 seconds) -
                                    <a href="#" @click.prevent="processAppointment">Create First Invoice</a>
                                </span>
                                </div>

                                <div class="field">
                                <span>
                                    <strong>Step 7:</strong>
                                    Allocate a payment against the invoice and submit the paid invoice to the client (estimated time : 30 seconds) -
                                    <a href="#" @click.prevent="processPayment">Create First Payment</a>
                                </span>
                                </div>

                                <div class="field">
                                <span>
                                    <strong>Step 8:</strong>
                                    Contact Us If You Need Help - Send an Email to info@kitrin.com or
                                    <a href="#" @click.prevent="processBookAppointment">Book an Appointment</a>
                                </span>
                                </div>

                                <div style="height: 25px;"></div>
                                <h3>Quick Start Guide (Estimated Time : 10 minutes)</h3>

                                <div class="flex justify-content-center mt-4">
                                    <div
                                        class="w-full"
                                        style="max-width: 900px; aspect-ratio: 16 / 9; position: relative;">
                                        <iframe
                                            src="https://iframe.mediadelivery.net/embed/568195/be93ce75-fa3e-4c4f-931f-e77018785574?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                            loading="lazy"
                                            style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                            allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                            allowfullscreen="true"></iframe>
                                    </div>
                                </div>

                                <div style="height: 25px;"></div>
                                <h3>Full Overview and Setup Guide (Estimated Time : 82 minutes)</h3>

                                <div class="flex justify-content-center mt-4">

                                    <div
                                        class="w-full"
                                        style="max-width: 900px; aspect-ratio: 16 / 9; position: relative;">
                                        <iframe
                                            src="https://iframe.mediadelivery.net/embed/568195/d9af70ec-e518-4f98-976d-09c63538e4ff?responsive=true&autoplay=false"
                                            loading="lazy"
                                            style="position: absolute; inset: 0; width: 100%; height: 100%; border: 0;"
                                            allowfullscreen>

                                        </iframe>
                                    </div>
                                </div>

                            </div>

                        </div>

                    </div>

                </div>
            </div>
        </div>
    </div>

    <IsoEvolveFooter/>

</template>

<script>
import IsoEvolveFooter from "@/components/heading/authentication/IsoEvolveFooter.vue";
import MenuHealthCompact from "@/components/menu/health/MenuHealthCompact.vue";
import {useUserStore} from "@/stores/UserStore";
import UserService from "@/service/UserService";
import userService from "@/service/UserService";
import MenuFinancialCompact from "@/components/menu/famodule/MenuFinancialCompact.vue";

export default {
    components: {
        MenuFinancialCompact,
        IsoEvolveFooter, MenuHealthCompact
    },
    setup() {
        const userStore = useUserStore()

        return {
            userStore
        }
    },
    async mounted() {
        try {
            await UserService.getUserPing();
        } catch (e) {
            this.userStore.clearUser();
            this.$router.push("login");
            return;
        }

        if (!this.userStore.user.id) {
            this.userStore.clearUser();
            this.$router.push('login');
            return;
        }

        await this.loadCompanyContext();
    },
    data() {

        return {
            profile: {},
            skipWelcome: true,
            userConfiguration: {},
            activeTab: 1
        }
    },
    watch: {
        'userStore.activeCompanyId': {
            immediate: false,
            async handler(newCompanyId, oldCompanyId) {
                if (!newCompanyId || newCompanyId === oldCompanyId) {
                    return;
                }

                await this.loadCompanyContext();
            }
        }
    },
    methods: {
        closeAllMenus() {
            document.body.click(); // triggers hideOnOutsideClick

            document.querySelectorAll('.p-component-overlay, .p-menu-overlay, .p-overlay, .p-tieredmenu-overlay')
                .forEach(el => el.remove());
        },
        safeNavigate(target) {
            this.closeAllMenus();
            setTimeout(() => {
                this.$router.push(target);
            }, 0);
        },
        async loadCompanyContext() {
            try {
                // Attempt to get user data
                const userData = await UserService.getUser(this.userStore.user.id);
                this.profile = userData.data;
            } catch (e) {
                this.userStore.clearUser();
                this.$router.push('login');
                return;
            }

            this.profile.companyId = this.userStore.activeCompanyId;

            const [userConfigurationData] = await Promise.all([
                UserService.getUserConfig(this.userStore.user.id),
            ]);

            this.userConfiguration = userConfigurationData.data;

            if (this.userConfiguration.showWelcome === 'Y') {
                this.skipWelcome = false;
            } else {
                this.skipWelcome = true;
            }
        },
        callUserManual() {
            this.safeNavigate('/usermanualIntroduction');
        },
        processBookAppointment() {
            window.open("https://kitrin.com/book-appointment", '_blank');
        },
        processConfiguration() {
            setTimeout(() => {
                this.$router.push("commonConfigurationBasic");
            }, 0);
        },
        processClient() {
            setTimeout(() => {
                this.$router.push("commonClients");
            }, 0);
        },
        processAppointment() {
            setTimeout(() => {
                this.$router.push("commonCalendar");
            }, 0);
        },
        processPayment() {
            setTimeout(() => {
                this.$router.push("commonFinancialInvoices");
            }, 0);
        },
        async onShowWelcomeChange() {

            try {
                if (this.skipWelcome === true) {
                    this.userConfiguration.showWelcome = 'N';
                } else {
                    this.userConfiguration.showWelcome = 'Y';
                }

                await userService.updateUserConfig(this.userStore.user.id, this.userConfiguration);

                try {
                    const [userConfigData] = await Promise.all([
                        UserService.getUserConfig(this.userStore.user.id)
                    ]);

                    this.userConfiguration = userConfigData.data;

                    if (this.userConfiguration.showWelcome === 'Y') {
                        this.skipWelcome = false;
                    } else {
                        this.skipWelcome = true;
                    }

                } catch (e) {
                    if (e.response && e.response.status === 401) {
                        this.$router.replace('/login');
                    } else {
                        this.userStore.clearUser();
                        this.$router.replace('/login');
                    }
                    return;
                }

                this.$toast.add({
                    severity: 'success',
                    summary: 'Successful',
                    detail: 'Configuration updated',
                    life: 3000
                });

            } catch (e) {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to update configuration. Please try again.',
                    life: 3000
                });
            }

        }
    }
};
</script>

<style scoped>
a {
    text-decoration: none;
}
</style>
